import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { HaPatientimport } from '../models/HaPatientImport.model';
import { ShareMultiplePatientModal } from '../models/ShareMultiplePatient.model';
import { FinalPatientSubmitModal } from '../models/FinalPatientSubmit.model';

@Injectable()
export class HaPatientlistService {
  constructor(private http: HttpClient) { }

  getPatientList(pageNo:number,text:string,eaLoginId:string) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getPatientList?pageNo='+ pageNo+'&text='+ text+'&eaLoginId='+ eaLoginId);
  }

  getDoctorsList() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getDoctorsList');
  }

  getPatientOtherInformation(patientId) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getPatientOtherInformation?patientId='+patientId);
  }


  getPatientCases(patientId) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getPatientCases?patientId='+ patientId);
  }

  getCaseCode(caseId){
    return this.http.get(globalAdd.Paneladdress+'api/HA/Patient/getPatientCaseCodes?sId='+caseId);
  }

  getSurveyList(eaPatientInfoId){
    return this.http.get(globalAdd.Paneladdress+'api/HA/Patient/getSurveyList?eaPatientInfoId='+eaPatientInfoId);
  }

  getPatientScheduledInfo(sId){
    return this.http.get(globalAdd.Paneladdress+'api/HA/Patient/getPatientScheduledInfo?sId='+sId);
  }

  getDoctorInfo(eaLogId){
    return this.http.get(globalAdd.Paneladdress+'api/HA/Patient/getDoctorInfo?eaLogId='+eaLogId);
  }

  getPatientPdfData(sId) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getPatientPdfData?scheduleId='+ sId);
  }
  getDoctors(patientId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getDoctorsToSharePatientWith?patientId='+patientId);
  }

  getDoctorsSch(sId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getDoctorsToShareScheduleWith?scheduleId='+ sId );
  }

  sharePatient(patientId,eaLoginId,saHospId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/sharePatient?patientId='+ patientId+'&eaLoginId='+eaLoginId+'&saHospId='+saHospId);
  }

  shareMultiplePatient(shareModal:ShareMultiplePatientModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Patient/shareMultiplePatient', shareModal);
  }

  shareSchedule(sId,eaLoginId,saHospId){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/shareSchedule?scheduleId='+sId+'&eaLoginId='+eaLoginId+'&saHospId='+saHospId);
  }

  uploadPatientExcel(File: File) {
    const upload: FormData = new FormData();
    upload.append("upload", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/importPatientData', upload, { headers, reportProgress: true, observe: 'events' });
  }

  finalSavePatientImport(finalSaveModal:FinalPatientSubmitModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/submitFinalRecords', finalSaveModal);
  }

  expotRejectedList(rejectedPatients: HaPatientimport[]) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/exportRejectedList', rejectedPatients);
  }

  getSharePatients() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getSharePatientList');
  }

  getSinglePdf(id){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Patient/getSinglePdf?id='+ id );
  }

}

